/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState: { currentUser?: API.CurrentUser & { permissions?: string[] } } | undefined,
) {
  const { currentUser } = initialState ?? {};
  const canAdmin = currentUser && (currentUser.access === 'admin' || currentUser.access === 'canAdmin');
  
  return {
    canAdmin,
    hasPerm: (code: string) => {
      if (canAdmin) return true; // 超级管理员拥有所有权限
      return currentUser?.permissions?.includes(code) ?? false;
    }
  };
}
